import { Box, useTheme } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import { Star } from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/assets/MBCP/icons';
import { Tag } from '@components';
import { rem } from '@helpers';

interface HeaderTagProps {
	text: string;
}

export const HeaderTag: React.FC<HeaderTagProps> = ({ text }) => {
	const { palette } = useTheme();
	return (
		<Box styles={{ marginBottom: rem(16) }}>
			<Tag
				size="small"
				mode="default"
				label={text.toUpperCase()}
				leftIcon={{
					source: () => (
						<Box styles={{ marginRight: rem(2) }}>
							<Star fill={palette.global.ui1} width={rem(16)} height={rem(16)} />
						</Box>
					),
				}}
				appearance={'neutralLight'}
			/>
		</Box>
	);
};
